module.exports = __webpack_public_path__ + "2d8b3b3.woff";